import React from 'react';

import FilterBar from '../FilterBar';
import ReportTable from './ReportTable';
import { KpiReportContainer } from '../styles';
import { REPORT_TABLES } from './utils';

const getReportData = (data, key) => {
  const reportDataArray = data[key].data;
  if (reportDataArray.length) {
    return reportDataArray[reportDataArray.length - 1];
  }
  return [];
};

const PlanningKPIReport = ({
  data,
  startDate,
  weekDaySelect,
  globalFilters,
  globalFilterApplied,
  kpiFilterApplied,
  onClickToChangeWeekDaySelect,
  onClickToChangeFilter,
  onClickToToggleFilterView,
  loading,
  persistParams,
  title,
}) => (
    <>
      <FilterBar
        weekStart={startDate}
        weekDaySelect={weekDaySelect}
        globalFilters={globalFilters}
        globalFilterApplied={globalFilterApplied}
        kpiFilterApplied={kpiFilterApplied}
        onClickToChangeWeekDaySelect={onClickToChangeWeekDaySelect}
        onClickToChangeFilter={onClickToChangeFilter}
        onClickToToggleFilterView={onClickToToggleFilterView}
        filterDisabled={loading}
        weekdayPickerDisabled={loading}
        persistParams={persistParams}
        title={title}
      />
      <KpiReportContainer>
        {REPORT_TABLES.map(({
          key, title: tableTitle, getColumns, width,
        }) => (
          <ReportTable
            key={key}
            data={getReportData(data, key)}
            title={tableTitle}
            loading={data[key].loadingQueue.length > 0}
            getColumns={getColumns}
            width={width}
          />
        ))}
      </KpiReportContainer>
    </>
);

export default PlanningKPIReport;
